/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_c_garden_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is an anagram of GARDEN?`)
};

const es_wu_c_garden_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es un anagrama de GARDEN?`)
};

const de_wu_c_garden_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist ein Anagramm von GARDEN?`)
};

const nl_wu_c_garden_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is een anagram van GARDEN?`)
};

const fr_wu_c_garden_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est une anagramme de GARDEN ?`)
};

const it_wu_c_garden_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è un anagramma di GARDEN?`)
};

const pt_br2_wu_c_garden_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é um anagrama de GARDEN?`)
};

const pt_wu_c_garden_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é um anagrama de GARDEN?`)
};

const ja_wu_c_garden_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GARDENのアナグラムは何ですか？`)
};

const zh_wu_c_garden_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GARDEN 的易位构词是什么？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_c_garden_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_c_garden_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_c_garden_faq1_q", locale)
	if (locale === "en") return en_wu_c_garden_faq1_q(inputs)
	if (locale === "es") return es_wu_c_garden_faq1_q(inputs)
	if (locale === "de") return de_wu_c_garden_faq1_q(inputs)
	if (locale === "nl") return nl_wu_c_garden_faq1_q(inputs)
	if (locale === "fr") return fr_wu_c_garden_faq1_q(inputs)
	if (locale === "it") return it_wu_c_garden_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_wu_c_garden_faq1_q(inputs)
	if (locale === "pt") return pt_wu_c_garden_faq1_q(inputs)
	if (locale === "ja") return ja_wu_c_garden_faq1_q(inputs)
	return zh_wu_c_garden_faq1_q(inputs)
};